<template>
  <div>
    <div class="card no-margin-bottom">
      <div class="card-block">
        <ui-data-table
          id="accounts-list"
          ref="list"
          :columns="columns"
          :filters="filters"
          :endpoint="endpoint"
          :actions="actions"
          size="sm"
        >
          <template
            slot="id"
            slot-scope="row"
          >
            <router-link :to="{ name: 'UsersEditAccount', params: { id: row.id } }">
              {{ row.id }}
            </router-link>
          </template>
          <template
            slot="users"
            slot-scope="row"
          >
            <router-link :to="{ name: 'UsersUsers', query: { 'filter.account_id': '=' + row.id } }">
              {{ row.users.length }}
            </router-link>
          </template>
          <template
            slot="vendors"
            slot-scope="row"
          >
            <template v-if="row['vendor_credentials'].length > 0">
              <a
                href="#"
                @click.prevent="showVendorCredentialsModal(row['id'])"
              >
                {{ row['vendor_credentials'].length }}
              </a>
            </template>
            <template v-else>
              {{ row['vendor_credentials'].length }}
            </template>
          </template>
          <template
            slot="marketplaces"
            slot-scope="row"
          >
            <template v-if="row['marketplace_credentials'].length > 0">
              <a
                href="#"
                @click.prevent="showMarketplaceCredentialsModal(row['id'])"
              >
                {{ row['marketplace_credentials'].length }}
              </a>
            </template>
            <template v-else>
              {{ row['marketplace_credentials'].length }}
            </template>
          </template>
          <template
            slot="is_active"
            slot-scope="row"
          >
            <i
              v-if="row.is_active === true"
              class="fa fa-check text-success"
            />
          </template>
        </ui-data-table>
      </div>
    </div>

    <router-view />

    <app-vendor-credentials-manage-for-account-modal
      v-model="vendorCredentials.visible"
      :account-id="vendorCredentials.accountId"
      @updated="refresh"
    />

    <app-marketplace-credentials-manage-for-account-modal
      v-model="marketplaceCredentials.visible"
      :account-id="marketplaceCredentials.accountId"
      @updated="refresh"
    />
  </div>
</template>

<script>
import ApiService from '../services/ApiService';
import ErrorsMixins from '../mixins/ErrorsMixins';
import AppVendorCredentialsManageForAccountModal from '../components/vendor-credentials/VendorCredentialsManageForAccountModal.vue';
import AppMarketplaceCredentialsManageForAccountModal from '../components/marketplace-credentials/MarketplaceCredentialsManageForAccountModal.vue';

export default {
  name: 'AppPageAccounts',
  components: {
    AppMarketplaceCredentialsManageForAccountModal,
    AppVendorCredentialsManageForAccountModal,
  },
  mixins: [ErrorsMixins],
  data() {
    return {
      columns: [
        {
          name: 'ID',
          key: 'id',
          sorting: true,
          styles: 'text-right',
        },
        {
          name: this.$t('Name'),
          key: 'name',
          sorting: true,
        },
        {
          name: this.$tc('Users', 2),
          key: 'users',
          styles: 'text-right',
        },
        {
          name: this.$tc('Vendors', 2),
          key: 'vendors',
          styles: 'text-right',
        },
        {
          name: this.$tc('Marketplaces', 2),
          key: 'marketplaces',
          styles: 'text-right',
        },
        {
          name: this.$t('Enabled'),
          key: 'is_active',
          sorting: true,
          styles: 'text-center',
        },
      ],
      filters: [
        {
          name: 'ID',
          key: 'id',
          type: 'integer',
        },
        {
          name: this.$t('Name'),
          key: 'name',
          type: 'string',
        },
      ],
      endpoint: `${ApiService.getLink('accounts')}&includes=users,marketplaceCredentials,vendorCredentials`,
      actions: [
        {
          icon: 'fa fa-plus',
          action: () => {
            this.$router.push({ name: 'UsersCreateAccount' });
          },
          label: this.$t('Create object', { object: this.$tc('Accounts', 1).toLowerCase() }),
        },
      ],
      vendorCredentials: {
        visible: false,
        accountId: 0,
      },
      marketplaceCredentials: {
        visible: false,
        accountId: 0,
      },
    };
  },
  methods: {
    showVendorCredentialsModal(accountId) {
      this.vendorCredentials.accountId = accountId;
      this.vendorCredentials.visible = true;
    },
    showMarketplaceCredentialsModal(accountId) {
      this.marketplaceCredentials.accountId = accountId;
      this.marketplaceCredentials.visible = true;
    },
    refresh() {
      this.$refs.list.refresh();
    },
  },
};
</script>
